import { useQuery } from '@tanstack/react-query';

import {
	getOperatorOptions,
	type OperatorDetailResponseView,
} from '@mopla/ticketshop-api';

export interface IOperatorDetail {
	termsConditionsUrl?: string;
	cancellationPolicyUrl?: string;
}

/**
 * Operator detail — GET /api/v1/operators/{operatorId}. Provides the
 * operator-specific legal links shown in the Zahlung section.
 */
export const useOperatorDetail = (
	operatorId: string | undefined
): { operatorDetail: IOperatorDetail | null } => {
	const { data } = useQuery({
		...getOperatorOptions({ path: { operatorId: operatorId ?? '' } }),
		enabled: !!operatorId,
		select: (dto: OperatorDetailResponseView): IOperatorDetail => ({
			termsConditionsUrl: dto.termsConditionsUrl,
			cancellationPolicyUrl: dto.cancellationPolicyUrl,
		}),
	});

	return { operatorDetail: data ?? null };
};
